import Request from "../Request";

export default class AuthRequest extends Request {
    /**
     * send OPT code for Register user
     *
     * @param {object} data mobile field.
     * @returns activate code send .
     */
    static Regsiter(data) {
        return AuthRequest.sendRequest(
            "user/signup",
            "POST", { data }, {
                toastSuccess: false,
            }
        );
    }

    /**
     * complete information after submit OTP
     *
     * @param {object} data object of first_name , last_name , username , password , c_password, etc.
     * @returns user info store
     */
    static RegsiterInfo(data) {
        return this.sendRequest(
            "profile/register/store",
            "POST", { data }, { toastSuccess: true, message: "اطلاعات با موفقیت ثبت شد" }
        );
    }

    /**
     *
     * @param {object} data username & password
     * @returns user log in.
     */
    static Login(data) {
        return AuthRequest.sendRequest("user/login", "POST", { data }, {});
    }

    /** exchange an Apple identity token (+ first-time name) for our own session */
    static LoginWithApple(data) {
        return AuthRequest.sendRequest("user/login/apple", "POST", { data }, {});
    }

    /** exchange a Google ID token for our own session */
    static LoginWithGoogle(credential) {
        return AuthRequest.sendRequest("user/login/google", "POST", { data: { credential } }, {});
    }

    /**
     *
     * @returns user logout successfully
     */
    static Logout() {
        return AuthRequest.sendRequest("user/logout", "POST", {}, {});
    }

    /**
     *
     * @param {object} data mini code
     * @returns user activate
     */
    static Activation(data) {
        return AuthRequest.sendRequest(
            "user/active/sms",
            "POST", { data }, {
                toastSuccess: false,
            }
        );
    }

    /**
     *
     * @param {object} data mobile or email
     * @returns code send
     */
    static ForgetPassword(data) {
        return AuthRequest.sendRequest(
            "user/password/forget/sms",
            "POST", { data }, {
                toastSuccess: false,
            }
        );
    }

    /**
     * Sends a password reset request via SMS to the user.
     *
     * @param {Object} data - The data to be sent in the request, typically including user identification information (e.g., phone number).
     * @returns {Promise} - A promise representing the outcome of the request.
     */
    static ForgetPasswordActivation(data) {
        return AuthRequest.sendRequest(
            "user/password/reset/sms",
            "POST", { data }, {
                toastSuccess: true,
                message: "کد ارسال شد",
            }
        );
    }

    /**
     * Sends a request to change the user's password.
     *
     * @param {Object} data - The data containing the current and new passwords.
     * @returns {Promise} - A promise representing the outcome of the request.
     */
    static ChangePassword(data) {
        return AuthRequest.sendRequest(
            "user/password/change",
            "POST", { data }, {
                toastSuccess: true,
                message: "تغییر پسورد موفقیت آمیز بود",
            }
        );
    }

    /**
     * Check username is already exist in registration
     *
     * @param {object} data username or mobile or email
     * @returns check user is exist or not
     */
    static UserExist(data) {
        return this.sendRequest("user/checkUser", "POST", { data }, {});
    }
}